
const TestComponent = () => {
    console.log("TestComponent rendered");
    return <h1>Test Page Loaded</h1>;
  };
  
export default TestComponent;